export const ACCOUNT_PREFERENCES = 'account.preferences';
export const ACCOUNT_COMMON_TEST = 'account.common_test';

export const lblPrefrenceHeading = 'lbl_prefrence_heading';
export const lblCommonBackLink = 'lbl_common_backLink';

export const lblPrefrenceSocialAccount = 'lbl_prefrence_social_account';

const MyPreferenceLabels = {
  account: {
    preferences: {
      [lblPrefrenceHeading]: 'My Preferences',
      [lblPrefrenceSocialAccount]: ' Social Accounts',
    },
    common_test: {
      [lblCommonBackLink]: 'Back',
    },
  },
};
export default MyPreferenceLabels;
